import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext, useEffect } from "react";
import { areObjectsEqual } from "Helpers/util";
import ProfileDataCardTitle from "../../common/ProfileDataCardTitle/ProfileDataCardTitle";
import AddressBox from "../ShippingAddress/AddressBox";
import accountStyles from "../styles.module.css";
import AccountContext from "../context";
import prefStyles from "../CommunicationPreferences/styles.module.css";
import H3Font from "../../common/H3Font";
import { useAppStore } from "Root/profile/lib/store";
const BillingAddress = () => {
    const { editMode, updateEditModeState, userAccount, onChangeData } = useContext(AccountContext);
    const { subscriberData } = useAppStore();
    const onChangeCheckbox = (value) => {
        onChangeData(value, "sameAddress");
    };
    const { billing_data, shipping_data } = userAccount;
    useEffect(() => {
        if (!areObjectsEqual(billing_data, shipping_data)) {
            onChangeCheckbox(false);
        }
        else {
            onChangeCheckbox(true);
        }
    }, [billing_data, shipping_data]);
    return (_jsxs("div", { className: "my-profile__basics-container my-profile__basics", children: [_jsx(ProfileDataCardTitle, { title: "Billing Address", editMode: editMode.billingAddress, setEdit: updateEditModeState, name: "billingAddress" }), _jsx("div", { className: "my-profile__items-wrapper", children: _jsx(_Fragment, { children: editMode.billingAddress ? (_jsx(AddressBox, { isUpdateCurrentBillingAddress: true, isBillingAddress: true })) : (_jsx("div", { className: `${prefStyles.bill_wrapper} my-profile__items-wrapper`, children: _jsxs("div", { className: accountStyles.shipping_address_text, children: [_jsx(H3Font, { children: `${subscriberData.first_name} ${subscriberData.first_name}` }), _jsx(H3Font, { children: subscriberData.billing_address1 }), _jsx(H3Font, { children: `${subscriberData.billing_city}, ${subscriberData.billing_province}` }), _jsx(H3Font, { children: subscriberData.billing_zip })] }) })) }) })] }));
};
export default BillingAddress;
